import useDidUpdateEffect from "@hooks/useDidUpdateEffect";

import { OrderFields } from "../../constants";
import useOrderData from "../../context/useOrderData";
import useOrderFormik from "../useOrderFormik";

// Hook listens for changes of starting country field
// and reloads countries to list depending on new value

const useCountriesToLoader = (): void => {
  const { values } = useOrderFormik();

  const { updateCountriesTo } = useOrderData();

  const startingCountry = values[OrderFields.STARTING_COUNTRY] || undefined;

  useDidUpdateEffect(() => {
    updateCountriesTo(startingCountry);
  }, [startingCountry, updateCountriesTo]);
};
export default useCountriesToLoader;
